import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { remCalc } from '../../util/style-util';
import { getRoutingForPage } from '../../util/workbook-util';

import diamond from 'assets/images/QuickJumpMenuIcons/diamond.png';
import green from 'assets/images/QuickJumpMenuIcons/green.png';
import heart from 'assets/images/QuickJumpMenuIcons/heart.png';
import hexagon from 'assets/images/QuickJumpMenuIcons/hexagon.png';
import moon from 'assets/images/QuickJumpMenuIcons/moon.png';
import octagon from 'assets/images/QuickJumpMenuIcons/octagon.png';
import orange from 'assets/images/QuickJumpMenuIcons/orange.png';
import pentagon from 'assets/images/QuickJumpMenuIcons/pentagon.png';
import red from 'assets/images/QuickJumpMenuIcons/red.png';
import square from 'assets/images/QuickJumpMenuIcons/square.png';
import star from 'assets/images/QuickJumpMenuIcons/star.png';
import yellow from 'assets/images/QuickJumpMenuIcons/yellow.png';
import blueOrange from 'assets/images/QuickJumpMenuIcons/blue-orange.png';
import grayBlack from 'assets/images/QuickJumpMenuIcons/gray-black.png';
import pinkBrown from 'assets/images/QuickJumpMenuIcons/pink-brown.png';
import redGreen from 'assets/images/QuickJumpMenuIcons/red-green.png';
import yellowPurple from 'assets/images/QuickJumpMenuIcons/yellow-purple.png';
import circles1 from 'assets/images/QuickJumpMenuIcons/circles1.png';
import circles2 from 'assets/images/QuickJumpMenuIcons/circles2.png';
import circle from 'assets/images/QuickJumpMenuIcons/circle.png';
import crescent from 'assets/images/QuickJumpMenuIcons/crescent.png';
import cross from 'assets/images/QuickJumpMenuIcons/cross.png';
import oval from 'assets/images/QuickJumpMenuIcons/oval.png';
import rectangle from 'assets/images/QuickJumpMenuIcons/rectangle2.png';
import rectangle1 from 'assets/images/QuickJumpMenuIcons/rectangle1.png';
import rectangle2 from 'assets/images/QuickJumpMenuIcons/rectangle.png';
import rectangle3 from 'assets/images/QuickJumpMenuIcons/rectangle3.png';
import rhombus from 'assets/images/QuickJumpMenuIcons/rhombus.png';
import triangle from 'assets/images/QuickJumpMenuIcons/triangle.png';

import { makeStyles } from '@mui/styles';

const linkIcons = {
  diamaond: diamond,
  heart: heart,
  hexagon: hexagon,
  moon: moon,
  octagon: octagon,
  pentagon: pentagon,
  rectangle: rectangle,
  rectangle1: rectangle1,
  rectangle2: rectangle2,
  rectangle3: rectangle3,
  triangle: triangle,
  circles1: circles1,
  circles2: circles2,
  circle: circle,
  crescent: crescent,
  cross: cross,
  oval: oval,
  rhombus: rhombus,
  square: square,
  star: star,
  red: red,
  green: green,
  orange: orange,
  yellow: yellow,
  'blue-orange': blueOrange,
  'gray-black': grayBlack,
  'pink-brown': pinkBrown,
  'red-green': redGreen,
  'yellow-purple': yellowPurple
} as any;

type Props = {
  symbol: {
    character: string;
    characterType: string;
    pageNumber: number | number[];
  };
  color: string;
  noLeftSpacing: boolean;
  closeMenu: () => void;
  useFlex: boolean;
  hasIcon: boolean;
} & any;

const iconWidths = {
  color: '200px',
  shape: '100px'
};

const PageCharacterLink = ({
  symbol,
  color,
  noLeftSpacing,
  closeMenu,
  useFlex,
  hasIcon
}: Props) => {
  const { pageLink, flex, evenSpacing, rightSpacingOnly } = useStyles({ color });
  const isZoom = Number.isInteger(symbol.pageNumber);
  const newPage: number = Array.isArray(symbol.pageNumber)
    ? symbol.pageNumber[0]
    : symbol.pageNumber;

  const params = useParams();
  const { pathname } = useLocation();
  const { path } = getRoutingForPage(newPage, { params, url: pathname }, isZoom, true);

  const className = `${pageLink} ${useFlex ? flex : ''} ${
    noLeftSpacing ? rightSpacingOnly : evenSpacing
  }`;

  return (
    <Link to={path} className={className} onClick={closeMenu}>
      {hasIcon ? (
        Object.prototype.hasOwnProperty.call(linkIcons, symbol.character.toLowerCase()) ? (
          <img
            src={linkIcons[symbol.character.toLowerCase()]}
            alt={symbol.character}
            width={iconWidths[symbol.characterType]}
          />
        ) : (
          symbol.character
        )
      ) : (
        symbol.character
      )}
    </Link>
  );
};

const useStyles = makeStyles(() => ({
  pageLink: (props: any) => ({
    color: props.color,
    fontSize: remCalc(32),
    minWidth: remCalc(30),
    display: 'inline-block',
    transition: 'transform 250ms',
    textDecoration: 'none',
    '&:active': {
      textDecoration: 'none'
    },
    '&:hover': {
      transform: 'scale(1.2)',
      textDecoration: 'none'
    },
    '&:focus': {
      transform: 'scale(1.2)',
      textDecoration: 'none'
    }
  }),
  flex: {
    minWidth: remCalc(50),
    flex: 1,
    margin: remCalc(10, 5),
    marginBottom: remCalc(16)
  },
  evenSpacing: {
    padding: remCalc(0, 10),
    margin: remCalc(0, 14),
    marginBottom: remCalc(18)
  },
  rightSpacingOnly: {
    paddingRight: remCalc(10),
    marginRight: remCalc(14)
  }
}));

export default PageCharacterLink;
